import * as React from 'react';
import { SeatInfoNoticeMessage } from './seat-info-error-message';
import { formatString } from '../../../helpers/string-format';


export interface ISeatInfoNoticeProps {
    needPriceTypeError: boolean;
    maxQuantityPriceTypeError: boolean;
    minQuantityPriceTypeError: boolean;
    maxQuantitySeatingOptionError: boolean;
    flexMinQuantityError: boolean;
    flexMaxQuantityError: boolean;
    showFlexPriceTypeError: boolean;
    needSeatingOptionError: boolean;
    noMoreExchangeableTicketsError: boolean;

    isExchange: boolean;
    exchangeTicketsRemaining: number;
    additionalPurchasable: number;
    exchangeTicketsRemainingMessage: string;
    availableAddOnsMessage: string;
    exchangeAdditionalTicketsRemainingMessage: string;

    noMoreExchangeTicketsRemainingError: string;
    priceTypeNotSelectedError: string;
    maxQuantityPriceTypeSelectedError: string;
    maxQuantitySeatingOptionSelectedError: string;
    maxQuantityPriceTypeSelectedErrorTextReplace: string;
    minQuantityPriceTypeSelectedErrorTextReplace: string;
    minimumSeatsRequiredMessage: string;
    priceTypeMinQuantityRequiredMessage: string;
    maximumSeatsRequiredMessage: string;
    missingSelectedSeatingOptionNotice: string;
}

class SeatInfoNotice extends React.PureComponent<ISeatInfoNoticeProps, any>{

    render() {
        const {
            isExchange,
            exchangeTicketsRemaining,
            additionalPurchasable,
            noMoreExchangeableTicketsError,
            needPriceTypeError,
            maxQuantityPriceTypeError,
            minQuantityPriceTypeError,
            maxQuantitySeatingOptionError,
            flexMinQuantityError,
            flexMaxQuantityError,
            showFlexPriceTypeError,
            needSeatingOptionError
        } = this.props;

        const maxQuantityPriceTypeErrorMessage = this.props.maxQuantityPriceTypeSelectedError.replace("{0}", this.props.maxQuantityPriceTypeSelectedErrorTextReplace);
        const minQuantityPriceTypeErrorMessage = this.props.priceTypeMinQuantityRequiredMessage.replace("{0}", this.props.minQuantityPriceTypeSelectedErrorTextReplace);

        let exchangeMessage = "";
        if (isExchange) {
            if (exchangeTicketsRemaining > 0) {
                exchangeMessage = formatString(this.props.exchangeTicketsRemainingMessage, [exchangeTicketsRemaining])
            } else {
                exchangeMessage = this.props.availableAddOnsMessage.trim().length > 0 ?
                    this.props.availableAddOnsMessage
                    :
                    formatString(this.props.exchangeAdditionalTicketsRemainingMessage, [additionalPurchasable])
            }
        }

        return (
            <div>
                <SeatInfoNoticeMessage errorKey="is exchange message" showNotice={isExchange} isError={false} message={exchangeMessage} />
                <SeatInfoNoticeMessage errorKey="exchange ticket limit error" showNotice={noMoreExchangeableTicketsError} isError={true} message={this.props.noMoreExchangeTicketsRemainingError} />
                <SeatInfoNoticeMessage errorKey="price type not selected error" showNotice={needPriceTypeError} isError={true} message={this.props.priceTypeNotSelectedError} />
                <SeatInfoNoticeMessage errorKey="price type max error" showNotice={maxQuantityPriceTypeError} isError={true} message={maxQuantityPriceTypeErrorMessage} />
                <SeatInfoNoticeMessage errorKey="special seating max error" showNotice={maxQuantitySeatingOptionError} isError={true} message={maxQuantityPriceTypeErrorMessage} />
                <SeatInfoNoticeMessage errorKey="flex min error" showNotice={flexMinQuantityError} isError={true} message={this.props.minimumSeatsRequiredMessage} />
                <SeatInfoNoticeMessage errorKey="flex max message" showNotice={flexMaxQuantityError} isError={false} message={this.props.maximumSeatsRequiredMessage} />
                <SeatInfoNoticeMessage errorKey="min price type error" showNotice={minQuantityPriceTypeError && !flexMinQuantityError} isError={true} message={minQuantityPriceTypeErrorMessage} />
                <SeatInfoNoticeMessage errorKey="max price type error" showNotice={showFlexPriceTypeError} isError={true} message={maxQuantityPriceTypeErrorMessage} />
                {
                    this.props.missingSelectedSeatingOptionNotice.length > 0 ?
                        <SeatInfoNoticeMessage errorKey="need seating option error" showNotice={needSeatingOptionError} isError={true} message={this.props.missingSelectedSeatingOptionNotice} />
                        : null
                }

            </div>
        );
    }
}

export default SeatInfoNotice;